import { render } from "./v-top-nav.vue?vue&type=template&id=0cfb9332"
import script from "./v-top-nav.vue?vue&type=script&lang=js"
export * from "./v-top-nav.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/datadrivet/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__